import React, { useState, useEffect, useCallback } from 'react';
import { AppBar, Toolbar, Select, MenuItem, FormControl, InputLabel, Box, Grid, Button } from '@mui/material';
import Skills from '../../components/planner/Skills';
import RealmAbilities from '../../components/planner/RealmAbilities';
import MasterLevels from '../../components/planner/MasterLevels';
import ChampionLevels from '../../components/planner/ChampionLevels';

const realmToClasses = {
    Albion: ['Armsman', 'Cabalist', 'Cleric', 'Friar', 'Heretic', 'Infiltrator', 'Mauler', 'Mercenary', 'Minstrel', 'Necromancer', 'Paladin', 'Reaver', 'Scout', 'Sorcerer', 'Theurgist', 'Wizard'],
    Midgard: ['Berserker', 'Bonedancer', 'Healer', 'Hunter', 'Mauler', 'Runemaster', 'Savage', 'Shadowblade', 'Shaman', 'Skald', 'Spiritmaster', 'Thane', 'Valkyrie', 'Warlock', 'Warrior'],
    Hibernia: ['Animist', 'Bainshee', 'Bard', 'Blademaster', 'Champion', 'Druid', 'Eldritch', 'Enchanter', 'Hero', 'Mauler', 'Mentalist', 'Nightshade', 'Ranger', 'Valewalker', 'Vampiir', 'Warden'],
};

const CharacterPlanner = () => {
    const [characterData, setCharacterData] = useState({
        realm: '',
        className: '',
        level: 50,
        realmRank: '1L0',
        realmLevel: 0,
        championLevel: 1,
        baseStats: {},
        skills: {},
    });
    const [classData, setClassData] = useState(null);

    useEffect(() => {
        const loadClassData = async () => {
            if (characterData.realm && characterData.className) {
                try {
                    const data = await import(`../../data/classes/${characterData.realm}/${characterData.className}.json`);
                    setClassData(data);
                    updateCharacterData({ classData: data }); // optional: for use in RealmAbilities if needed
                } catch (err) {
                    console.error("Failed to load class data:", err);
                    setClassData(null);
                }
            }
        };

        loadClassData();
    }, [characterData.realm, characterData.className]);


    const updateCharacterData = (updatedFields) => {
        setCharacterData((prevData) => ({
            ...prevData,
            ...(typeof updatedFields === 'function' ? updatedFields(prevData) : updatedFields),
        }));
    };

    const generateLevelOptions = () => {
        const levels = [];
        for (let i = 1; i <= 39; i++) levels.push(i);
        for (let i = 40; i <= 50; i++) {
            levels.push(i);
            if (i < 50) levels.push(i + 0.5);
        }
        return levels;
    };

    return (
        <Box>
            <AppBar position="static">
                <Toolbar>
                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                        <InputLabel>Realm</InputLabel>
                        <Select value={characterData.realm} onChange={(e) => updateCharacterData({ realm: e.target.value, className: '', race: '', baseStats: {}, skills: {} })}>
                            {Object.keys(realmToClasses).map((realm) => (
                                <MenuItem key={realm} value={realm}>{realm}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small" disabled={!characterData.realm}>
                        <InputLabel>Class</InputLabel>
                        <Select value={characterData.className} onChange={(e) => updateCharacterData({ className: e.target.value, race: '', baseStats: {}, skills: {} })}>
                            {realmToClasses[characterData.realm]?.map((cls) => (
                                <MenuItem key={cls} value={cls}>{cls}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                        <InputLabel>LVL</InputLabel>
                        <Select value={characterData.level} onChange={(e) => updateCharacterData({ level: e.target.value })}>
                            {generateLevelOptions().map((lvl) => <MenuItem key={lvl} value={lvl}>{lvl}</MenuItem>)}
                        </Select>
                    </FormControl>

                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                        <InputLabel>RR</InputLabel>
                        <Select value={parseInt(characterData.realmRank)} onChange={(e) => updateCharacterData({ realmRank: `${e.target.value}L${characterData.realmLevel}` })}>
                            {[...Array(14).keys()].map((i) => <MenuItem key={i + 1} value={i + 1}>{i + 1}</MenuItem>)}
                        </Select>
                    </FormControl>

                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                        <InputLabel>RL</InputLabel>
                        <Select value={characterData.realmLevel} onChange={(e) => updateCharacterData({ realmLevel: e.target.value, realmRank: `${parseInt(characterData.realmRank)}L${e.target.value}` })}>
                            {[...Array(10).keys()].map((i) => <MenuItem key={i} value={i}>{i}</MenuItem>)}
                        </Select>
                    </FormControl>

                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                        <InputLabel>CL</InputLabel>
                        <Select value={characterData.championLevel} onChange={(e) => updateCharacterData({ championLevel: e.target.value })}>
                            {[...Array(15).keys()].map((i) => <MenuItem key={i + 1} value={i + 1}>{i + 1}</MenuItem>)}
                        </Select>
                    </FormControl>

                    <Button variant="contained" color="primary" onClick={() => console.log(characterData)} sx={{ ml: 2 }}>
                        Save
                    </Button>
                </Toolbar>
            </AppBar>

            <Box p={3}>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Skills
                            characterData={characterData}
                            updateCharacterData={updateCharacterData}
                            classData={classData}
                        />                    </Grid>
                    <Grid item xs={12} md={6}>
                        <RealmAbilities
                            characterData={characterData}
                            updateCharacterData={updateCharacterData}
                            classData={classData}
                        />
                    </Grid>
                </Grid>

                {/*<Box mt={4}>*/}
                {/*    <MasterLevels characterData={characterData} updateCharacterData={updateCharacterData} />*/}
                {/*</Box>*/}

                {/*<Box mt={4}>*/}
                {/*    <ChampionLevels characterData={characterData} updateCharacterData={updateCharacterData} />*/}
                {/*</Box>*/}
            </Box>
        </Box>
    );
};

export default CharacterPlanner;
